// set 3 and true, if wants to active the prep stage
// set 2 and false, if wants to disable the prep stage

export const GAME_CONFIG = {
  lastStageIndex: 2,
  hasPrepStage: false,
};
